import appAxios from "services/axios";

export const DebtorAdminService = {
  findByIIN: (iin) => appAxios.get(`/admin/external/debtor/${iin}`),
};
